import {accessCategoryTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = accessCategoryTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const accessCategoryReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default accessCategoryReducer;
